module.exports = __webpack_public_path__ + "img/icon_aside_more_hover.00c29760.svg";